import { SANITIZED_ATTR_PREFIX_REGEX, SANITIZED_ATTR_PREFIX, ENCODED_PREFIX_REGEX } from '../constants.mjs';
import { isValidAttributeName, hasAttributes } from './utilities.mjs';

function sanitizeAttributeHook(node, data) {
  const {
    attrName: currentAttrName
  } = data;
  const {
    ownerDocument: domPurifyDocument
  } = node;
  if (isAlreadySanitizedOrEncoded(currentAttrName)) return;
  const safeAttrName = currentAttrName.replace(SANITIZED_ATTR_PREFIX_REGEX, '');
  if (safeAttrName in data.allowedAttributes) return;
  if (isValidAttributeName(safeAttrName, domPurifyDocument)) {
    node.setAttribute(`${SANITIZED_ATTR_PREFIX}${safeAttrName}`, data.attrValue);
  }
  node.removeAttribute(safeAttrName);
}
function unsanitizeAttributes(element) {
  if (!element || !hasAttributes(element)) return;
  const {
    ownerDocument: domPurifyDocument
  } = element;
  const attributes = Array.from(element.attributes);
  attributes.filter(({
    name
  }) => isASanitizedAttribute(name)).forEach(({
    name: sanitizedAttrName,
    value
  }) => {
    const originalAttrName = attrWithoutSanitizedPrefix(sanitizedAttrName);
    if (isValidAttributeName(originalAttrName, domPurifyDocument)) {
      element.setAttribute(originalAttrName, value);
    }
    element.removeAttribute(sanitizedAttrName);
  });
}
function attrWithoutSanitizedPrefix(attrName) {
  return attrName.replace(SANITIZED_ATTR_PREFIX, '');
}
function isASanitizedAttribute(attrName) {
  return SANITIZED_ATTR_PREFIX_REGEX.test(attrName);
}
function isAlreadySanitizedOrEncoded(attrName) {
  return isASanitizedAttribute(attrName) || ENCODED_PREFIX_REGEX.test(attrName);
}

export { sanitizeAttributeHook, unsanitizeAttributes };
